import { fontWeights } from "@dana/MobiusOverrides/styles/typography";
import { savedOrderListTableStyles } from "@dana/Overrides/Widgets/SavedOrderList/SavedOrderListTable";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

savedOrderListTableStyles.shipToLabelHeader = mergeToNew(savedOrderListTableStyles.shipToLabelHeader, {
    css: css`
        button {
            justify-content: start;
        }
    `,
});

savedOrderListTableStyles.subtotalCell = mergeToNew(savedOrderListTableStyles.subtotalCell, {
    css: css`
        padding: 0 32px 0px 0px;
    `,
});

savedOrderListTableStyles.orderDateHeader = mergeToNew(savedOrderListTableStyles.orderDateHeader, {
    css: css`
        button {
            justify-content: start;
        }
    `,
});

savedOrderListTableStyles.orderDateCell = mergeToNew(savedOrderListTableStyles.orderDateCell, {
    css: css`
        a {
            text-decoration: none;
            font-weight: ${fontWeights.semiBold};

            span {
                text-decoration: none;
            }
        }
    `,
});

savedOrderListTableStyles.container = mergeToNew(savedOrderListTableStyles.container, {
    css: css`
        position: relative;
    `,
});